import {
  endpoints,
  EventInterfaces,
  sendEvent as sendEventToTracker
} from "@comparaonline/event-tracker";

import config from "../../../../config/app";
import { useAppContext } from "../../../lib/appContext";

const { appName, appVersion } = config;

type BasicEventInput = Pick<EventInterfaces.BasicEvent, "businessUnit" | "countryCode">;

export const buildBasicEventData = ({
  businessUnit,
  countryCode
}: BasicEventInput): EventInterfaces.BasicEvent => ({
  appName,
  appVersion,
  businessUnit,
  countryCode
});

export const sendEvent = (
  basicDataInput: BasicEventInput,
  eventData: any,
  afterSendCallback?: () => void,
  timeout?: number
) => {
  const basicData = buildBasicEventData(basicDataInput);
  const fullData = {
    ...basicData,
    ...eventData
  };
  sendEventToTracker(endpoints.SNOWPLOW_APP, fullData, afterSendCallback, timeout);
  sendEventToTracker(endpoints.TAG_MANAGER_APP, fullData, afterSendCallback, timeout);
};

export const useSendEvent = (afterSendCallback?: () => void, timeout?: number) => {
  const { countryCode, businessUnitConfig } = useAppContext();
  return (eventData: any) =>
    sendEvent(
      { countryCode, businessUnit: businessUnitConfig.businessCode },
      eventData,
      afterSendCallback,
      timeout
    );
};
